import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Plus, Sparkles } from "lucide-react";
import { luxuryAddOns } from "../mock";

const LuxuryAddOns = () => {
  return (
    <div>
      <section className="relative pt-36 pb-16 bg-[#0a121a] border-b border-white/5 overflow-hidden">
        <div className="absolute -top-24 left-1/2 -translate-x-1/2 h-64 w-[40rem] rounded-full bg-[var(--gold)]/8 blur-3xl" />
        <div className="relative max-w-4xl mx-auto px-5 text-center">
          <p className="reveal inline-flex items-center gap-2 font-display text-xs uppercase tracking-[0.4em] text-[var(--gold)] mb-4">
            <Sparkles size={14} /> Elevate Every Detail
          </p>
          <h1 className="reveal font-display text-4xl sm:text-6xl font-extrabold text-white">Luxury Add-Ons</h1>
          <p className="reveal mt-5 text-lg text-muted-foreground max-w-2xl mx-auto">
            Enhance your car service experience with our exclusive luxury add-ons — from champagne &amp; coolers to fresh bouquets of roses. Elevate your journey.
          </p>
        </div>
      </section>

      <section className="py-20">
        <div className="max-w-7xl mx-auto px-5 lg:px-8">
          <div className="grid gap-7 sm:grid-cols-2 lg:grid-cols-3">
            {luxuryAddOns.map((a) => (
              <div key={a.id} className="reveal lux-card group flex flex-col rounded-2xl border border-white/10 bg-[#13212e] overflow-hidden">
                <div className="img-zoom relative h-56">
                  <img src={a.image} alt={a.title} className="h-full w-full object-cover" />
                  <div className="absolute inset-0 bg-gradient-to-t from-[#13212e] via-transparent to-transparent" />
                  <span className="absolute top-4 right-4 rounded-full bg-[var(--gold)] px-3.5 py-1 text-xs font-bold uppercase tracking-widest text-[#0c1620]">{a.price}</span>
                </div>
                <div className="flex flex-1 flex-col p-6">
                  <h3 className="font-display text-lg font-bold text-white">{a.title}</h3>
                  <p className="mt-2 flex-1 text-sm text-muted-foreground leading-relaxed">{a.desc}</p>
                  <Link to="/book" className="mt-5 inline-flex items-center justify-center gap-2 rounded-full border border-[var(--gold)]/50 py-2.5 text-xs font-semibold uppercase tracking-widest text-[var(--gold)] transition-all group-hover:bg-[var(--gold)] group-hover:text-[#0c1620]">
                    <Plus size={14} /> Add to Booking
                  </Link>
                </div>
              </div>
            ))}
          </div>

          <div className="reveal mt-16 text-center">
            <Link to="/book" className="btn-gold inline-flex items-center gap-2 rounded-full px-8 py-4 text-sm font-semibold uppercase tracking-widest">
              Start Your Booking <ArrowRight size={16} />
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default LuxuryAddOns;
